<template>
  <CRow>
    <CCol col="12" sm="12">
      <CCard>
        <CCardHeader>
          {{ $route.name }}
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol col="12" sm="10">
              <date-picker
                v-model="searchData.date_range"
                :shortcuts="false"
                :editable="false"
                :clearable="false"
                range-separator="~"
                range
                width="100%"
                value-type="date"
                format="YYYY-MM-DD"
              />
            </CCol>
            <CCol col="12" sm="2">
              <CButton color="primary" block @click="getHolidayDates()">{{
                $t("search")
              }}</CButton>
            </CCol>
          </CRow>
          <hr />
          <CRow>
            <CCol col="12" sm="10" class="d-flex align-items-center">
              <font class="text-muted">{{
                $t("search_info", searchInfo)
              }}</font>
            </CCol>
            <CCol col="12" sm="2">
              <CButton
                color="info"
                block
                @click="() => (createHolidayDateModal = { modal: true })"
                >{{ $t("create_holiday_date") }}</CButton
              >
            </CCol>
          </CRow>
          <hr />
          <v-client-table :columns="columns" :data="data" :options="options">
            <font slot="holiday_date" slot-scope="props">
              {{ $moment(props.row.holiday_date).format("YYYY-MM-DD") }}
            </font>
            <div slot="action" slot-scope="props" class="text-center">
              <CButtonGroup>
                <CButton
                  color="danger"
                  v-bind="{ variant: 'outline' }"
                  @click="
                    () =>
                      (deleteHolidayDateModal = {
                        data: $_.extend(props.row, {
                          name: props.row.holiday_type.name,
                        }),
                        modal: true,
                      })
                  "
                  >{{ $t("delete") }}</CButton
                >
              </CButtonGroup>
            </div>
          </v-client-table>
        </CCardBody>
      </CCard>

      <CreateHolidayDateModal
        :data="createHolidayDateModal.data"
        :show="createHolidayDateModal.modal"
        @showUpdate="(show) => (createHolidayDateModal.modal = show)"
        @formSubmit="getHolidayDates()"
      />

      <DeleteHolidayDateModal
        :data="deleteHolidayDateModal.data"
        :show="deleteHolidayDateModal.modal"
        @showUpdate="(show) => (deleteHolidayDateModal.modal = show)"
        @formSubmit="getHolidayDates()"
      />
    </CCol>
  </CRow>
</template>

<script>
import CreateHolidayDateModal from "./modal/CreateHolidayDateModal";
import DeleteHolidayDateModal from "./modal/DeleteHolidayDateModal";

export default {
  name: "holidayDate",
  components: {
    CreateHolidayDateModal,
    DeleteHolidayDateModal,
  },
  data() {
    return {
      columns: ["holiday_type.name", "holiday_date", "action"],
      data: [],
      options: {
        headings: {
          "holiday_type.name": this.$t("holiday_type"),
          holiday_date: this.$t("holiday_date"),
          action: this.$t("action"),
        },
        sortable: ["holiday_type.name", "holiday_date"],
        filterable: ["holiday_type.name", "holiday_date"],
      },
      searchInfo: { at: "-", count: 0, sec: 0 },
      searchData: {
        date_range: [
          this.$moment({ hour: 0 }).subtract(30, "d"),
          this.$moment({ hour: 0 }).add(30, "d"),
        ],
      },
      createHolidayDateModal: { data: {}, modal: false },
      deleteHolidayDateModal: { data: {}, modal: false },
    };
  },
  computed: {},
  mounted: function () {
    this.getHolidayDates();
  },
  methods: {
    getHolidayDates() {
      const startMoment = this.$moment();
      const loader = this.$loading.show();
      // prepare payload: send dates as -1 day to match backend expectation
      const payload = this.$_.clone(this.searchData);
      if (payload && payload.date_range && payload.date_range.length === 2) {
        const [start, end] = payload.date_range;
        const adjStart = this.$moment(start).isValid()
          ? this.$moment(start).subtract(1, "day").toDate()
          : start;
        const adjEnd = this.$moment(end).isValid()
          ? this.$moment(end).subtract(1, "day").toDate()
          : end;
        payload.date_range = [adjStart, adjEnd];
      }
      this.$store
        .dispatch("getHolidayDates", payload)
        .then((res) => {
          // convert incoming dates: +1 day for display
          this.data = (res || []).map((r) => ({
            ...r,
            holiday_date: this.$moment(r.holiday_date).isValid()
              ? this.$moment(r.holiday_date).add(1, "day").format("YYYY-MM-DD")
              : r.holiday_date,
          }));
          this.searchInfo.at = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          this.searchInfo.count = (res || []).length;
          this.searchInfo.sec = this.$moment().diff(startMoment) / 1000;
          loader.hide();
        })
        .catch((e) => {
          this.$swal("Error", e.message ? e.message : e, "error");
          loader.hide();
        });
    },
  },
};
</script>
